import { useMemo } from 'react';

import { BookerSearchViewModel } from '../../../BookerSearchViewModel';
import { Container } from './styled';
import {
  generateAbroadLocationsCategories,
  generateLocalLocationsCategories,
} from '../../../helpers';
import CategoriesSearchList from '../Lists/CategoriesSearchList';

type Props = {
  locations?: BookerSearchViewModel[];
  onChange: (item: BookerSearchViewModel) => void;
  callBack?: (item: BookerSearchViewModel) => void;
  showRemoveButton?: boolean;
  onRemoveItem?: (item: BookerSearchViewModel) => void;
  inputLocation?: string;
};

const CategoryBaseHotelsList = ({
  locations = [],
  onChange,
  onRemoveItem,
  inputLocation,
  showRemoveButton,
  callBack,
}: Props) => {
  const items = useMemo(() => {
    const localDrawerData = generateLocalLocationsCategories({
      label: 'YURT İÇİ',
      locations,
    });
    const abroadDrawerData = generateAbroadLocationsCategories({
      label: 'YURT DIŞI',
      locations,
    });

    return {
      localDrawerData,
      abroadDrawerData,
    };
  }, [locations]);

  return (
    <Container>
      {items?.localDrawerData?.totalCount > 0 ? (
        <CategoriesSearchList
          label={items?.localDrawerData?.label}
          items={items?.localDrawerData?.items}
          onChange={onChange}
          onRemoveItem={onRemoveItem}
          showRemoveButton={showRemoveButton}
          inputLocation={inputLocation}
          callBack={callBack}
        />
      ) : null}

      {items?.abroadDrawerData?.totalCount > 0 ? (
        <CategoriesSearchList
          label={items?.abroadDrawerData?.label}
          items={items?.abroadDrawerData?.items}
          onChange={onChange}
          onRemoveItem={onRemoveItem}
          showRemoveButton={showRemoveButton}
          inputLocation={inputLocation}
          callBack={callBack}
        />
      ) : null}
    </Container>
  );
};

export default CategoryBaseHotelsList;
